import { pluralize } from '@art-suite/art-core-ts';
import { css } from '@emotion/react';
import React from 'react';

import { LAYOUT2 } from '../../Styles';
import { TYPOGRAPHY2 } from '../../Styles/TYPOGRAPHY2';
import { PhotoGallery, PhotoGallerySection } from './PhotoGallery';

const GALLERY_SET_HEADER_STYLE = css`
  label: PHOTO_GALLERY_SET_HEADER_STYLE;
  ${TYPOGRAPHY2.tinyBold};
  color: var(--text2);
  text-transform: uppercase;
  height: ${LAYOUT2.spacing4}px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border);
  padding: 0 ${LAYOUT2.spacing1p5}px;
  background-color: var(--background3);
`;

const GALLERY_SET_HEADER_STICKY_STYLE = css`
  label: PHOTO_GALLERY_SET_HEADER_STICKY_STYLE;
  position: sticky;
  top: 0;
  z-index: 11;
`;

const PHOTO_GALLERY_CONTAINER_STYLE = css`
  label: PHOTO_GALLERY_CONTAINER_STYLE;
  padding: 0 ${LAYOUT2.spacing1}px;
`;

export type PhotoGallerySetGallery = {
  header: React.ReactNode;
  sections: PhotoGallerySection[];
};

export const PhotoGallerySet = ({
  scanId,
  galleries,
  headerIsSticky,
}: {
  scanId: string;
  galleries: PhotoGallerySetGallery[];
  headerIsSticky?: boolean;
}) => {
  return (
    <>
      {galleries.map((gallery, index) => (
        <div key={index}>
          <div css={[GALLERY_SET_HEADER_STYLE, headerIsSticky && GALLERY_SET_HEADER_STICKY_STYLE]}>
            {gallery.header} ({pluralize(gallery.sections.reduce((acc, section) => acc + section.photos.length, 0), 'photo')})
          </div>
          <div css={PHOTO_GALLERY_CONTAINER_STYLE}>
            <PhotoGallery scanId={scanId} sections={gallery.sections} />
          </div>
        </div>
      ))}
    </>
  );
};
